import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { t } from '../../i18n';

/** <cadence-empty-state heading="…" message="…"> with optional CTA in default slot. */
@customElement('cadence-empty-state')
export class CadenceEmptyState extends LitElement {
  @property() heading = '';
  @property() message = '';

  static styles = css`
    :host { display: block; }
    .wrap {
      background: var(--color-bg-primary); border: 1px dashed var(--color-border);
      border-radius: var(--radius-lg); padding: var(--space-6);
      text-align: center; color: var(--color-text-secondary);
      display: flex; flex-direction: column; align-items: center; gap: 10px;
    }
    h3 { margin: 0; color: var(--color-text-primary); font-size: 1.05rem; }
    p { margin: 0; }
  `;

  render() {
    return html`
      <div class="wrap" data-section="empty-state">
        <h3>${this.heading || t('common.states.empty')}</h3>
        ${this.message ? html`<p>${this.message}</p>` : ''}
        <slot></slot>
      </div>
    `;
  }
}
